import React from "react"
import NativeSelect, { NativeSelectProps } from "@mui/material/NativeSelect"
import { styled } from "@mui/material/styles"

import { colors } from "theme"

type Props = NativeSelectProps & { light?: boolean }

const SelectComponent = styled(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ light, ...restProps }: Props) => (
    <NativeSelect variant="filled" {...restProps} />
  ),
)(({ light = false }) => ({
  background: light ? colors.white : colors.ghostWhite,
  backgroundColor: light ? colors.white : colors.ghostWhite,
  border: "none",
  borderRadius: 9,
  height: "56px",
  overflow: "hidden",
  padding: "4px 32px 5px 10px",

  "& :focus": {
    background: "transparent !important",
    backgroundColor: "transparent !important",
  },

  "&:before, &:after": {
    display: "none",
  },

  "& .MuiInputBase-root": {
    "&:hover": {
      backgroundColor: light ? colors.white : colors.ghostWhite,
    },
    "&.Mui-focused": {
      backgroundColor: light ? colors.white : colors.ghostWhite,
    },
  },

  "& .MuiNativeSelect-select": {
    backgroundColor: light ? colors.white : colors.ghostWhite,
    paddingRight: "0 !important",
    "&:focus": {
      backgroundColor: "transparent !important",
    },
  },
}))

SelectComponent.defaultProps = {
  light: false,
}

export default SelectComponent
